{
  "browserNotSupported": {
    "title": "Modul kunne ikke indlæses",
    "text": "Skift til en opdateret browser for at anvende reservedelsbrowseren."
  },
  "main": {
    "more": "Mere tilbehør",
    "findMore": "Du kan finde tilbehør til eftermontering/ombygning og opgradering af dit køretøj her i vores omfattende tilbud. Det tilbehør, som du har valgt, vil blive sendt til din {{brand}}-partner sammen med din køretøjsforespørgsel.",
    "topOffers": "TOP-tilbud",
    "article": "<0>{{min}} - {{max}} / </0>{{productCount}} Produkter",
    "noArticleFound": "0 Produkter",
    "oemHint": "Vælg passende tilbehør til din {{brand}} nu!",
    "noBrand": "Vælg passende tilbehør til dit køretøj nu!",
    "outOfOrder": "Der er desværre ingen produkter til rådighed i øjeblikket.<0/>Vi er i øjeblikket ved at opdatere vores katalog.<0/>Besøg os venligst igen på et senere tidspunkt.",
    "nextSlide": "Næste",
    "prevSlide": "Forrige"
  },
  "cart": {
    "add": "Produkt tilføjet til køretøjet",
    "fullPrice": "Pris køretøj og tilbehør",
    "priceWithoutCar": "Pris tilbehør"
  },
  "navigation": {
    "zoom": "Zoom",
    "toggleSearch": "Skift søgning",
    "cart": "Kurv",
    "cartDelete": "Fjern vare fra kurv",
    "vehicle": "Udvalgt køretøj",
    "maxBookmarksReached": "Højst 15 produkter nås",
    "filter": {
      "toggleFilter": "Skift filter",
      "topProducts": "TOP-tilbud",
      "reset": "Nulstil filter",
      "ready": "Udfør",
      "show": "Vis resultater"
    },
    "searching": {
      "submit": "Søg",
      "close": "Luk",
      "placeholder": "Find matchende tilbehør ...",
      "suggestions": "Søgeforslag",
      "categories": "Kategorier",
      "products": "Produkter",
      "productCount": "{{count}} produkt",
      "productCount_other": "{{count}} produkter",
      "showAll": "Vis {{count}} resultat",
      "showAll_other": "Vis alle {{count}} resultater",
      "expand": "Udvidet søgning",
      "show": "Vis resultater",
      "found": {
        "withCategory": "Søgeresultater for \"{{fuzzy}}\" i kategorien \"{{category}}\"",
        "withOutCategory": "Søgeresultater for \"{{fuzzy}}\" fra alle kategorier"
      }
    },
    "share": "Del",
    "back": "Tilbage",
    "details": "Detaljer",
    "add": "Tilføj",
    "remove": "Fjern",
    "close": "Luk",
    "filtern": "Filter",
    "closeFilter": "Luk filter"
  },
  "productDetail": {
    "gallery": {
      "jumpToImageNumber": "Gå til billede {{number}}"
    },
    "articleNumber": "Artikelnummer",
    "relatedArticle": "Denne artikel interesserer dig måske også:",
    "brand": "Mærke",
    "priceBox": {
      "withVatAndMounting": "inkl. moms & montage",
      "withVat": "inkl. moms",
      "recommendedRetailPrice": "oprindeligt",
      "historicMinimalPurchasePrice": "Laveste pris de seneste 30 dage",
      "priceDetails": "Prisdetaljer",
      "priceDetailsHeadline": "Prisoplysninger for denne vare",
      "priceToday": "Pris for denne vare i dag",
      "priceDetails30Days": "Laveste pris i de 30 dage før prisændringen",
      "close": "Luk",
      "addItem": "Tilføj artikel",
      "removeItem": "Fjern artikel"
    },
    "infoBox": {
      "description": "Beskrivelse",
      "vehicles": "Passer til følgende modeller",
      "empty": "Der er ingen særlige køretøjstildelinger for dette produkt.",
      "contacts": "Producent"
    },
    "contacts": {
      "manufacturer-contact": " Producentens kontaktinformation",
      "responsible-contact": "Ansvarlig person inden for EU",
      "trademark": "Mærke"
    }
  },
  "productList": {
    "oemHint": "Originalt tilbehør til din {{brand}}"
  }
}
